import { StatusTablet } from "../../../components/statusView";
import { statusFlow } from "../../../components/utils/allProductStatus";
import MobileSection from "../../ui/MobileSection";
import {
  STATUS_FLOW_COLORS,
  STATUS_FLOW_DESCRIPTIONS,
} from "./statusFlowDescriptions";

export default function MobileStatusFlow({ flowKey, title }) {
  const steps = statusFlow[flowKey];
  const bgColor = STATUS_FLOW_COLORS[flowKey];
  const descriptions = STATUS_FLOW_DESCRIPTIONS[flowKey];
  const entries = Object.entries(steps ?? {});

  return (
    <MobileSection title={title}>
      <div className="flex flex-col items-center gap-2">
        {entries.map(([name, label], index) => (
          <div key={name} className="flex flex-col items-center gap-2">
            <StatusTablet
              label={label}
              name={name}
              description={descriptions[name]}
              bgColor={bgColor}
            />
            {index < entries.length - 1 ? (
              <span className="text-sm text-laranjinha/50" aria-hidden="true">↓</span>
            ) : null}
          </div>
        ))}
      </div>
    </MobileSection>
  );
}
